module.exports = __webpack_public_path__ + "static/yarrabend-disclaimer-nov2020.f5268505.pdf";


//////////////////
// WEBPACK FOOTER
// ./static/yarrabend-disclaimer-nov2020.pdf
// module id = 657
// module chunks = 114276838955818